import React, { useEffect, useState } from "react";
import { Divider, Space, Typography, Pagination, Spin } from 'antd';
import WidgetAjax from '../../../../widget/WidgetAjax';
import Config from "../../../../config/Config";
import { LoadingOutlined, } from '@ant-design/icons';
import EnterpriseIcon from "../icon/enterpriseIcon";
import NoData from '../../../com/NoData'
import './index.scss';

const path = Config.getBasePath();
let filePath = Config.getFilePath();
const CardTable = ({ 
    options = {}, 
    params = {},
    history,
}) =>
{
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);

    const onChange = (page, pageSize) =>
    {
        setPage(page);
        setPageSize(pageSize);
        getData(page, pageSize);
    }

    const getData = (pageNum, pageSizeNum) =>
    {
        let newParams = {
            ...params,
            page: pageNum || page,
            records: pageSizeNum || pageSize,
        }
        setLoading(true);
        WidgetAjax.ajax({ 
            url: path + options.url, 
            params: newParams, 
            callback: (res) =>
            {
                if (res.status == 0)
                {
                    setData(res.results);
                    setTotal(res.total);
                }
                setLoading(false);
            } 
        })
    }
    const turnToDetail = (data) =>
    {
        history.push({
            pathname: '/home/enterprise/detail',
            state: { data: data }
        })
    }

    useEffect(() => {
        if (options.url && options.url !== '') {
            getData(1);
        }
    }, [params])

    return <Spin spinning={loading} indicator={<LoadingOutlined />}>
        <div className="enterprise-card-table-wrap">
            <div className="enterprise-card-table">
                {
                    data && data.length > 0
                    ?   data.map((item, index) =>
                    {
                        return <div className="enterprise-card-item" key={index} onClick={() => turnToDetail(item)}>
                            <div className="enterprise-card-item-content">
                                {
                                    item.ENTLOGO || item.LOGO
                                    ?   <img 
                                            src={filePath + 'enterprise/M' + item.id + '.png'} 
                                            alt="" 
                                            className="enterprise-item-logo-img" 
                                        />
                                    :   <img src={require('../../../../img/pinzhunzhun/enterprise/enterprise_icon.png')} alt="" className="enterprise-item-logo-img" />
                                }
                                <div className="enterprise-card-item-content-name">
                                    <div className="enterprise-card-item-title" title={item.ENTNAME}>{item.ENTNAME || '-'}</div>
                                    <div className="enterprise-card-item-tag">
                                        
                                        {
                                            item.ENTTYPE_CN && item.ENTTYPE_CN !== ''
                                            ?   <span title={item.ENTTYPE_CN}>{item.ENTTYPE_CN}</span>
                                            :   ''
                                        }
                                        {
                                            item.SCALE_CN && item.SCALE_CN !== ''
                                            ?   <span title={item.SCALE_CN}>{item.SCALE_CN}</span>
                                            :   ''
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="enterprise-card-item-job">
                                    <div className="enterprise-card-item-job_left">
                                        <span>热招</span>
                                        <Divider type="vertical" />
                                        <div className="enterprise-card-item-job_item">
                                            {
                                                item.jobs && item.jobs.length > 0
                                                ?   <span>{item.jobs[0].JOBNAME}</span>
                                                :   <></>
                                            }
                                        </div>
                                    </div>
                                    <div className="enterprise-card-item-job_salary">
{
                                            item.jobs && item.jobs.length > 0
                                            ?   <span>{item.jobs[0].SALFROM}-{item.jobs[0].SALTO}</span>
                                            :   <></>
                                        }
                                    </div>
                            </div>
                        </div>
                        })
                    :   loading 
                        ?   <></>
                        :   <div className="enterprise-card-table-nodata">
                                <NoData width={'400px'} height={'400px'}/>
                            </div>
                }
            </div>
            {
                total && total > 20
                ?   <div className="cardtable-pagination">
                        <Pagination 
                            showQuickJumper 
                            defaultCurrent={page} 
                            total={total} 
                            pageSize={pageSize}
                            pageSizeOptions={[20, 50, 100, 500]}
                            onChange={onChange} 
                        />
                    </div>
                :   <></>
            }
        </div>
    </Spin>
}

export default CardTable;